import appLogger from "../../utils/app-logger";
import AuthServiceApi from "../../services/auth-service-api";
import { toast } from "react-toastify";
import { EMPTY_GUID } from "../../utils/constants";
import UserServiceApi from "../../services/user-service-api";
import DocBuilderService from "../../services/doc-builder-api";
import { jwtDecode } from "jwt-decode";
import {
  readCookie,
  createCookie,
  deleteCookie,
  deletedomainCookie,
  PerquisiteBountyEnable,
} from "../../utils/helpers";
import SingleSignOnApi from "../../services/single-sign-on-api";
import ssoHandler from "../../utils/ssohandler";
import ABTestService from "../../services/abtest-service-api";
import { currentDomain } from "../../utils/general-config";
import { DomainEnum } from "../../services/enum/environment-enum";

const signInUser = async (data, domain) => {
  clearStorage();
  return AuthServiceApi.LoginUser(data)
    .then((response) => {
      if (response) {
        // TO make sure old values does not exists..
        const { jwtToken, refreshToken, expiresAt, ssoToken, legacyToken } = response;
        localStorage.setItem("jwtToken", jwtToken, domain);
        localStorage.setItem("refreshToken", refreshToken, domain);
        localStorage.setItem("expiresAt", expiresAt, domain);
        createCookie("jwtToken", jwtToken, 1, domain);
        createCookie("refreshToken", refreshToken, 1, domain);
        createCookie("pdfsimplirefreshToken", refreshToken, 10, domain);
        if (currentDomain() !== DomainEnum.WORKSIMPLI) {
          createCookie("pdfsimpliauth", JSON.stringify(response), 10, domain);
        }
        createCookie("expiresAt", expiresAt, 1, domain);
        createCookie("ssoToken", ssoToken, 1, domain);
        createCookie("legacyTicket", legacyToken, 1, domain);
        createCookie("ssoauth", "1", 1, domain);
        const decodedJwtToken = jwtDecode(jwtToken);
        if (!!decodedJwtToken && !!decodedJwtToken.org_ids) {
          createCookie("orgId", decodedJwtToken.org_ids, 1, domain);
        }
        appLogger.log("inside signUpUser1 ");
        // call user service to get userguid

        return UserServiceApi.getUserByUserName(encodeURIComponent(data.username), data.tenantGroupId).then(
          async (userResponse) => {
            //
            if (userResponse) {
              const { userGuid, isMigrated, isAccountLocked, perquisiteBountyKey, parentUserGuid } = userResponse;
              let isGuestUser = !!parentUserGuid ? true : false;
              var validUserGuid = userGuid;
              if (userGuid.includes("-") == false) {
                validUserGuid = userGuid.replace(/(.{8})(.{4})(.{4})(.{4})(.{12})/, "$1-$2-$3-$4-$5");
              }
              createCookie("userguid", validUserGuid, 1);
              await ssoHandler();
              let isPerquisiteBountyEnable = PerquisiteBountyEnable(perquisiteBountyKey, validUserGuid);
              return {
                validUserGuid: validUserGuid,
                isMigratedUser: isMigrated,
                isAccountLocked: isAccountLocked,
                isPerquisiteBountyEnable: isPerquisiteBountyEnable,
                isGuestUser: isGuestUser,
              };
            }
          }
        );
      }
    })
    .catch((error) => {
      // TODO :: Display error message
      if (error.isAxiosError) {
        let errorMsg = `${error.toString()} `;
        if (error.response?.data?.isAccountLocked) {
          console.log("Your account is locked. Please connect to customer support");
          toast.error(errorMsg);
        } else {
          toast.error(errorMsg);
        }
        throw error;
      }
    });
};

const getUserDocs = (userguid) => {
  return DocBuilderService.findByUserGuid(userguid)
    .then((response) => {
      return response;
    })
    .catch((error) => { });
};

const clearStorage = () => {
  localStorage.removeItem("jwtToken");
  localStorage.removeItem("refreshToken");
  localStorage.removeItem("expiresAt");
  deleteCookie("jwtToken");
  deleteCookie("refreshToken");
  deletedomainCookie("jwtToken");
  deleteCookie("ssoToken");
  deleteCookie("ssoauth");
  deleteCookie("legacyTicket");
  deleteCookie("ssopl");
  deleteCookie("userguid");
  deleteCookie("orgId");
};
const partnerLogOut = () => {
  return function (dispatch) {
    SingleSignOnApi.partnerLogOut("PS")
      .then((ssoResponse) => { })
      .catch((error) => { });
    SingleSignOnApi.partnerLogOut("SS")
      .then((ssoResponse) => { })
      .catch((error) => { });
  };
};

const getAbridgedUserDocs = (userguid, typeofdoc) => {
  return DocBuilderService.findByUserGuidAbridged(userguid, typeofdoc)
    .then((response) => {
      if (response) {
        if (!!response && response.documents.length > 0) {
        }
      } else {
      }
      return response;
    })
    .catch((error) => {
      console.log("error at findByUserGuidAbridged");
    });
};
const getUserAbridged = () => {
  return UserServiceApi.getUserObject();
};
const getUserDocumentAttributes = (userguid, typeofdoc) => {
  return DocBuilderService.getUserDocumentAttributes(userguid, typeofdoc)
    .then((response) => {
      if (response) {
        if (!!response) {
        }
        appLogger.log("inside getUserDocumentAttributes response");
      } else {
        appLogger.log("inside getUserDocumentAttributes response else");
      }
      return response;
    })
    .catch((error) => {
      console.log("error at getUserDocumentAttributes");
      return { docCount: 0 };
    });
};

const validateGuestToken = (data) => {
  return UserServiceApi.validateGuestToken(data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log("Error");
      return null;
    });
};

const getABtestData = async (abTestId, userGuid) => {
  try {
    const response = await ABTestService.AbTestData(abTestId, userGuid);
    return response;
  } catch (error) {
    console.log("Error");
  }
  return null;
};

const SwitchVisitorUserAbTest = (switchData) => {
    //pass this data format request from component
    if(switchData && switchData.AbTestId && switchData.AbTestId != EMPTY_GUID && switchData.UserId && switchData.UserId != EMPTY_GUID
        && switchData.VisitorId && switchData.VisitorId != EMPTY_GUID)
    {
      const data = {
        AbTestId: switchData.AbTestId,
        UserGuid: switchData.UserId,
        VisitorID: switchData.VisitorId,
        PortalCD: switchData.portalCD,
      };
      return ABTestService.SwitchVisitorUser(data).then((response) => {});
  }
};

const signInJcUser = async (data, domain) => {
  clearStorage();
  return AuthServiceApi.AuthenticateJCPartnerUser(data)
    .then((response) => {
      if (response) {
        // TO make sure old values does not exists..
        const { jwtToken, refreshToken, expiresAt, ssoToken, legacyToken } = response;
        localStorage.setItem("jwtToken", jwtToken, domain);
        localStorage.setItem("refreshToken", refreshToken, domain);
        localStorage.setItem("expiresAt", expiresAt, domain);
        createCookie("jwtToken", jwtToken, 1, domain);
        createCookie("refreshToken", refreshToken, 1, domain);
        createCookie("pdfsimplirefreshToken", refreshToken, 10, domain);
        if (currentDomain() !== DomainEnum.WORKSIMPLI) {
          createCookie("pdfsimpliauth", JSON.stringify(response), 10, domain);
        }
        createCookie("expiresAt", expiresAt, 1, domain);
        createCookie("ssoToken", ssoToken, 1, domain);
        createCookie("legacyTicket", legacyToken, 1, domain);
        createCookie("ssoauth", "1", 1, domain);
        const decodedJwtToken = jwtDecode(jwtToken);

        if (!!decodedJwtToken && !!decodedJwtToken.org_ids) {
          createCookie("orgId", decodedJwtToken.org_ids, 1, domain);

          let sid = decodedJwtToken[Object.keys(decodedJwtToken).find((key) => key.endsWith("/sid"))];

          let userGuid = sid.replaceAll("-", "");

          return UserServiceApi.getUserByUserGuid(userGuid).then(async (userResponse) => {
            if (userResponse) {
              const { userGuid, isMigrated, isAccountLocked, perquisiteBountyKey, parentUserGuid } = userResponse;
              let isGuestUser = !!parentUserGuid ? true : false;
              var validUserGuid = userGuid;
              if (userGuid.includes("-") == false) {
                validUserGuid = userGuid.replace(/(.{8})(.{4})(.{4})(.{4})(.{12})/, "$1-$2-$3-$4-$5");
              }
              createCookie("userguid", validUserGuid, 1);
              await ssoHandler();
              let isPerquisiteBountyEnable = PerquisiteBountyEnable(perquisiteBountyKey, validUserGuid);
              return {
                validUserGuid: validUserGuid,
                isMigratedUser: isMigrated,
                isAccountLocked: isAccountLocked,
                isPerquisiteBountyEnable: isPerquisiteBountyEnable,
                isGuestUser: isGuestUser,
              };
            }
          });
        }
        appLogger.log("inside signUpUser1 ");
        // call user service to get userguid
      }
    })
    .catch((error) => {
      // TODO :: Display error message
      if (error.isAxiosError) {
        let errorMsg = `${error.toString()} `;
        if (error.response?.data?.isAccountLocked) {
          console.log("Your account is locked. Please connect to customer support");
          toast.error(errorMsg);
        } else {
          toast.error(errorMsg);
        }
        throw error;
      }
    });
};
export {
  signInUser,
  getUserDocs,
  partnerLogOut,
  getAbridgedUserDocs,
  getUserDocumentAttributes,
  validateGuestToken,
  getUserAbridged,
  getABtestData,
  SwitchVisitorUserAbTest,
  signInJcUser,
};
